// extracted by mini-css-extract-plugin
module.exports = {"brokers-container":"LeaseCard_brokers-container__StiKI","broker-text":"LeaseCard_broker-text__1ymZH","broker-name":"LeaseCard_broker-name__3zQ-5"};